import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MaterialModule } from './material/material.module'
import { LocalizedCurrencyPipe } from './pipes/localized-currency.pipe'
import { PaginationComponent } from './components/pagination/pagination.component'
import { ConfigurableDropdownComponent } from './components/configurable-dropdown/configurable-dropdown.component'
import { TableSkeletonLoaderComponent } from './components/loader/table-skeleton-loader/table-skeleton-loader.component'
import { FreezeComponent } from './components/freeze/freeze.component'
import { SkeletonCardComponent } from './components/skeletons-loader/skeleton-card/skeleton-card.component'
import { SkeletonListComponent } from './components/skeletons-loader/skeleton-list/skeleton-list.component'
import { SkeletonTableComponent } from './components/skeletons-loader/skeleton-table/skeleton-table.component'
import { SkeletonActionsComponent } from './components/skeletons-loader/skeleton-actions/skeleton-actions.component'
import { SkeletonHeaderComponent } from './components/skeletons-loader/skeleton-header/skeleton-header.component'
import { ClickOutsideDirective } from '@educational-initiatives/angular-web-utilities'
import { RouterModule } from '@angular/router'
import { SuccessDialogComponent } from './components/success-dialog/success-dialog.component'
import { ErrorDialogComponent } from './components/error-dialog/error-dialog.component'
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component'
import { CallbackDialogComponent } from './components/callback-dialog/callback-dialog.component'
import { LoadingStateComponent } from './components/loading-state/loading-state.component'
import { StateDistrictFieldsComponent } from './components/state-district-fields/state-district-fields.component'
import { SectionTitleComponent } from './components/section-title/section-title.component'
import { EiButtonComponent } from './components/ei-button/ei-button.component'
import { EiSearchBarComponent } from './components/ei-search-bar/ei-search-bar.component'
import { EiInputFieldComponent } from './components/ei-input-field/ei-input-field.component'
import { EiTableComponent } from './components/ei-table/ei-table.component'
import { UserMenuComponent } from './components/user-menu/user-menu.component'
import { SvgIconComponent } from './components/svg-icon/svg-icon.component'

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MaterialModule,
        LocalizedCurrencyPipe,
        LoadingStateComponent,
        FreezeComponent,
        ClickOutsideDirective,
        FormsModule,
        ReactiveFormsModule,
        ConfigurableDropdownComponent,
        LoadingStateComponent,
        EiButtonComponent,
        EiSearchBarComponent,
        EiInputFieldComponent,
        EiTableComponent,
        SvgIconComponent,
        UserMenuComponent,
        TableSkeletonLoaderComponent,
        SkeletonCardComponent,
        SkeletonListComponent,
        SkeletonTableComponent,
        SkeletonActionsComponent,
        SkeletonHeaderComponent,
        PaginationComponent,
        SuccessDialogComponent,
        ErrorDialogComponent,
        ConfirmationDialogComponent,
        CallbackDialogComponent,
        StateDistrictFieldsComponent,
        SectionTitleComponent,
    ],
    exports: [
        TableSkeletonLoaderComponent,
        ClickOutsideDirective,
        CommonModule,
        RouterModule,
        MaterialModule,
        FormsModule,
        LocalizedCurrencyPipe,
        LoadingStateComponent,
        FreezeComponent,
        SkeletonCardComponent,
        SkeletonListComponent,
        SkeletonTableComponent,
        SkeletonActionsComponent,
        SkeletonHeaderComponent,
        PaginationComponent,
        ConfigurableDropdownComponent,
        SuccessDialogComponent,
        ErrorDialogComponent,
        ConfirmationDialogComponent,
        CallbackDialogComponent,
        LoadingStateComponent,
        StateDistrictFieldsComponent,
        SectionTitleComponent,
        EiButtonComponent,
        EiSearchBarComponent,
        EiInputFieldComponent,
        EiTableComponent,
        UserMenuComponent,
        SvgIconComponent,
    ],
})
export class SharedModule {}
